
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatasourcesDisplayGridRowDataFragment, PublishedDatasourceSortOrder, UpstreamDatasourcesFilteredByFieldQuery, UpstreamDatasourcesFilteredByFieldQueryVariables, WorkbookUpstreamDatasourcesQuery, WorkbookUpstreamDatasourcesQueryVariables , UpstreamDatasourcesFilteredByFieldDocument , WorkbookUpstreamDatasourcesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import {
  DatasourcesDisplayGrid,
  DatasourcesDisplayGridRowData,
  getRowDataForDatasource,
} from '../sharedDisplayGrid/DatasourcesDisplayGrid';
import { DatasourcesValidSortFields } from '../sorting/sortProviders/DatasourcesGridSortProvider';

type QueryVariables = WorkbookUpstreamDatasourcesQueryVariables;
type QueryResults = WorkbookUpstreamDatasourcesQuery;
type QueryResultListNode = DatasourcesDisplayGridRowDataFragment;
type GridRowData = DatasourcesDisplayGridRowData;

type QueryVariablesWithFilter = UpstreamDatasourcesFilteredByFieldQueryVariables;
type QueryResultsWithFilter = UpstreamDatasourcesFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.workbooks && resultData.workbooks[0] && resultData.workbooks[0].upstreamDatasourcesConnection;
}

function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter):
  ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.fieldsConnection && resultData.fieldsConnection.nodes &&
    resultData.fieldsConnection.nodes[0] && resultData.fieldsConnection.nodes[0].upstreamDatasourcesConnection;
}


export type WorkbookUpstreamDatasourcesQueryGridProps =
  GridSortProps<DatasourcesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredFieldId: string | null;
    readonly rowCount: number | null;
  };

export function WorkbookUpstreamDatasourcesQueryGrid(props: WorkbookUpstreamDatasourcesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyUpstreamDatasourcesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyUpstreamFilteredDatasourcesLineageGridMessage();

  return (
    props.filteredFieldId ? (
      // Query with Selected Field as Filter
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={UpstreamDatasourcesFilteredByFieldDocument}
        partialQueryVariables={{ selectedFieldId: props.filteredFieldId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForDatasource}
      >
        {({ rowStore }) =>
          <DatasourcesDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={WorkbookUpstreamDatasourcesDocument}
        partialQueryVariables={{ workbookVizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as PublishedDatasourceSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForDatasource}
      >
        {({ rowStore }) =>
          <DatasourcesDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        }
      </PaginatedQueryWrapper>
    )
  )
}
